var $57968e8209de2557$exports = {};
$57968e8209de2557$exports = {
  "buttonLabel": "Mostrar sugerencias",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opci\xF3n");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opciones");
      }
    }), " disponible(s).");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Se ha unido al grupo ".concat(args.groupTitle, ", con ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opci\xF3n");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opciones");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", seleccionado",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugerencias",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", seleccionado");
  }
};
export { $57968e8209de2557$exports as default };